<template>
  <div class="appIndex">
    <!-- <menuframe></menuframe> -->
    <div id="myClient">
      <div class="searchs">
        <div class="searchInline">
          <el-input v-model="searchParams.mobile" placeholder="请输入手机号" clearable></el-input>
        </div>
        <div class="searchInline">
          <el-select v-model="searchParams.memberLevel" @change="submitSearch" placeholder="用户身份" clearable>
            <el-option label="VIP" :value="0"></el-option>
            <el-option label="SVIP" :value="1"></el-option>
          </el-select>
        </div>
        <div class="searchInline">
          <el-select v-model="searchParams.isBindCar" @change="submitSearch" placeholder="是否绑车" clearable>
            <el-option label="已绑车" :value="true"></el-option>
            <el-option label="未绑车" :value="false"></el-option>
          </el-select>
        </div>
        <div class="searchInline">
          <el-select v-model="searchParams.isStar" @change="submitSearch" placeholder="是否星标" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </div>
        <!-- <div class="searchInline">
          <el-select v-model="searchParams.isAccount" @change="submitSearch" placeholder="联系次数" clearable>
            <el-option label="0次" :value="0"></el-option>
            <el-option label="1次" :value="1"></el-option>
            <el-option label="2次" :value="2"></el-option>
            <el-option label="3次" :value="3"></el-option>
            <el-option label="4次" :value="4"></el-option>
            <el-option label="5次及以上" :value="5"></el-option>
          </el-select>
        </div> -->
        <!-- <div class="searchInline">
          <el-select v-model="searchParams.isAccount" @change="submitSearch" placeholder="选择渠道来源" clearable>
            <el-option label="石化" :value="1"></el-option>
            <el-option label="交管" :value="0"></el-option>
          </el-select>
        </div> -->
        <div class="searchInline">
          <el-input v-model="searchParams.agentMobile" placeholder="请输入合伙人手机号" clearable></el-input>
        </div>
        <div class="searchInline">
          <el-button type="primary" @click="submitSearch">搜索</el-button>
        </div>
        <div class="searchInline">
          <el-button type="primary" @click="searchClear(1)">清除</el-button>
        </div>
      </div>
      <div class="searchs">
        <div class="searchInline" style="display:flex;align-items:center;">
          用户分配时间：
          <el-button type="text" :class="userChange == 0 ? 'blue' : ''" @click="vipClick(0)">不限</el-button>
          <el-button type="text" :class="userChange == 1 ? 'blue' : ''" @click="vipClick(1)">今天</el-button>
          <el-button type="text" :class="userChange == 2 ? 'blue' : ''" @click="vipClick(2)">昨天</el-button>
          <div class="right_time">
            <el-date-picker
              v-model="searchParams.time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              @change="submitSearch"
              clearable>
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="searchs">
        <div class="searchInline">
          VIP到期时间：
          <el-button type="text" :class="vipEnd == 0 ? 'blue' : ''" @click="vipDateClick(0)">不限</el-button>
          <el-button type="text" :class="vipEnd == 1 ? 'blue' : ''" @click="vipDateClick(1)">1个月以下</el-button>
          <el-button type="text" :class="vipEnd == 2 ? 'blue' : ''" @click="vipDateClick(2)">1-3个月</el-button>
          <el-button type="text" :class="vipEnd == 3 ? 'blue' : ''" @click="vipDateClick(3)">3-5个月</el-button>
          <el-button type="text" :class="vipEnd == 4 ? 'blue' : ''" @click="vipDateClick(4)">5个月以上</el-button>
        </div>
      </div>
      <div class="searchs">
        <div class="searchInline">
          审车到期时间：
          <el-button type="text" :class="vehEnd == 0 ? 'blue' : ''" @click="shencheClick(0)">不限</el-button>
          <el-button type="text" :class="vehEnd == 1 ? 'blue' : ''" @click="shencheClick(1)">1个月以下</el-button>
          <el-button type="text" :class="vehEnd == 2 ? 'blue' : ''" @click="shencheClick(2)">1-3个月</el-button>
          <el-button type="text" :class="vehEnd == 3 ? 'blue' : ''" @click="shencheClick(3)">3-5个月</el-button>
          <el-button type="text" :class="vehEnd == 4 ? 'blue' : ''" @click="shencheClick(4)">5个月以上</el-button>
        </div>
      </div>
      <div class="searchs">
        <div class="searchInline">
          保险到期时间：
          <el-button type="text" :class="insuranceEnd == 0 ? 'blue' : ''" @click="baoxianClick(0)">不限</el-button>
          <el-button type="text" :class="insuranceEnd == 1 ? 'blue' : ''" @click="baoxianClick(1)">1个月以下</el-button>
          <el-button type="text" :class="insuranceEnd == 2 ? 'blue' : ''" @click="baoxianClick(2)">1-3个月</el-button>
          <el-button type="text" :class="insuranceEnd == 3 ? 'blue' : ''" @click="baoxianClick(3)">3-5个月</el-button>
          <el-button type="text" :class="insuranceEnd == 4 ? 'blue' : ''" @click="baoxianClick(4)">5个月以上</el-button>
        </div>
      </div>
      <div class="searchs">
        <div class="searchInline">
          车龄：
          <el-button type="text" :class="carYear == 0 ? 'blue' : ''" @click="carYearClick(0)">不限</el-button>
          <el-button type="text" :class="carYear == 1 ? 'blue' : ''" @click="carYearClick(1)">2年</el-button>
          <el-button type="text" :class="carYear == 2 ? 'blue' : ''" @click="carYearClick(2)">2-6年</el-button>
          <el-button type="text" :class="carYear == 3 ? 'blue' : ''" @click="carYearClick(3)">6-15年</el-button>
          <el-button type="text" :class="carYear == 4 ? 'blue' : ''" @click="carYearClick(4)">15年以上</el-button>
        </div>
      </div>
      <div class="contentView">
        <div class="top_table">
          <div class="left">
            <div class="tip_btn"><i class="el-icon-warning-outline"></i>已选择<span style="color:#25a0ef;">{{selectLength}}</span>项，建议每次总数不大于<span>50</span>项</div>
            <div class="tip_btn" style="color:#25a0ef;cursor:pointer;" @click="toggleSelection()" v-if="selectLength > 0">清空</div>
          </div>
          <div class="right" v-if="selectLength > 0">
            <div class="right_btn" @click="creatTask()">创建任务</div>
          </div>
        </div>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :row-key="getRowKeys1" @selection-change="handleSelectionChange" style="width: 100%;">
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55">
          </el-table-column>
          <el-table-column
            prop="isStar"
            label="星标"
            min-width="100">
            <template slot-scope="scope">
              <span @click="setStar(scope.row)" class="to_able" v-if="scope.row.isStar" ><i class="el-icon-star-on"></i></span>
              <span @click="setStar(scope.row)" style="cursor:pointer;" v-else><i class="el-icon-star-on"></i></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="usertype"
            label="用户身份"
            min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.isSvip">SVIP用户</span>
              <span v-else-if="scope.row.isVip" >VIP用户</span>
              <span v-else>普通用户</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="memberTel"
            label="手机号"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="car"
            label="车辆信息"
            min-width="100">
          </el-table-column>
          <!-- <el-table-column
            prop="reType"
            label="渠道/来源"
            min-width="100">
          </el-table-column> -->
          <el-table-column
            prop="distributeTime"
            label="用户分配时间"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="agentTel"
            label="合伙人手机号"
            min-width="100">
          </el-table-column>
          <!-- <el-table-column
            prop="logintime"
            label="最后登录时间">
          </el-table-column> -->
          <!-- <el-table-column
            prop="contactCount"
            label="联系次数"
            min-width="120">
          </el-table-column> -->
          <!-- <el-table-column
            prop="operatorName"
            label="操作人"
            min-width="120">
          </el-table-column> -->
          <el-table-column
            class="tableOptions"
            label="操作"
            min-width="120">
            <template slot-scope="scope">
              <span class="to_able" @click="openCall(scope.row)">呼叫</span>
              <span class="to_able" @click="dialogShow()">绑定逸创客服</span>
              <span class="to_able" @click="openSubmit(scope.row)">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="sizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,40]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalResult">
          </el-pagination>
        </div>
      </div>
      <el-dialog title="绑定逸创云客服账号" :visible.sync="dialog.submit.show" width="500px">
        <el-form :model="dialog.submit" label-width="100px">
          <el-form-item label="用户名">
            <el-input style="width:250px;" v-model="dialog.submit.userName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input style="width:250px;" v-model="dialog.submit.password" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog.submit.show = false">取 消</el-button>
          <el-button type="primary" @click="bindCall">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'myClient',
  components: {
    menuframe: require('../base/menuframe').default,
    frameAdmin: require('../frame/admin.vue').default
  },
  data () {
    return {
      searchParams: {
        mobile: '',
        memberLevel: '', // 0vip 1 svip
        isStar: '',
        agentMobile: '', // 合伙人手机号
        isBindCar: '',
        distributeTimeStart: '', // 分配时间
        distributeTimeEnd: '',
        insuranceType: '', // 保险到期时间 0不限 1:2年以内 2:2-6年 3:6-15年 4:15年以上
        vehType: '', // 审车到期 0不限 1:1个月以下 2:1-3个月 3:3到5个月 4:5个月以上
        carType: '', // 车龄 0不限 1:2年以内 2:2-6年 3:6-15年 4:15年以上
        vipType: '',
        isAccount: '',
        time: [],
        pageSize: 10,
        pageIndex: 0
      },
      ids: '',
      managerId: '',
      userChange: 0,
      vipEnd: 0,
      insuranceEnd: 0,
      vehEnd: 0,
      carYear: 0,
      tableData: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      multipleSelection: [],
      newList: [],
      selectLength: 0,
      email_address: '2811022610@qq.com',
      password: '967106',
      formLabelWidth: '',
      dialog: {
        submit: {
          show: false,
          userName: '',
          password: ''
        }
      }
    };
  },
  created () {
    if (this.$route.query.time1 && this.$route.query.time1) {
      this.searchParams.time[0] = this.$route.query.time1;
      this.searchParams.time[1] = this.$route.query.time2;
      this.axios.get(`/doubleTask/getManagerId`, {}).then(res => {
        this.managerId = res.data.resultData.managerId;
        this.getList();
      });
    } else if (this.$route.query.vipType) { // vip到期
      this.searchParams.vipType = this.$route.query.vipType;
      this.searchParams.memberLevel = 0;
      this.vipEnd = this.$route.query.vipType;
      this.axios.get(`/doubleTask/getManagerId`, {}).then(res => {
        this.managerId = res.data.resultData.managerId;
        this.getList();
      });
    } else if (this.$route.query.vehType) { // 审车到期
      this.searchParams.vehType = this.$route.query.vehType;
      this.searchParams.memberLevel = 0;
      this.vehEnd = this.$route.query.vehType;
      this.axios.get(`/doubleTask/getManagerId`, {}).then(res => {
        this.managerId = res.data.resultData.managerId;
        this.getList();
      });
    } else if (this.$route.query.insuranceType) { // 保险到期
      this.searchParams.insuranceType = this.$route.query.insuranceType;
      this.searchParams.memberLevel = 0;
      this.insuranceEnd = this.$route.query.insuranceType;
      this.axios.get(`/doubleTask/getManagerId`, {}).then(res => {
        this.managerId = res.data.resultData.managerId;
        this.getList();
      });
    } else {
      this.axios.get(`/doubleTask/getManagerId`, {}).then(res => {
        this.managerId = res.data.resultData.managerId;
        this.getList();
      });
    }
  },
  methods: {
    // 获取列表数据
    getList () {
      this.axios.get('/member/managerMemberList', {
        params: {
          managerId: this.managerId ? this.managerId : '', // 管家主键
          memberLevel: this.searchParams.memberLevel,
          isStar: this.searchParams.isStar, // 是否星标
          mobile: this.searchParams.mobile || this.$route.query.mobile,
          agentMobile: this.searchParams.agentMobile,
          isBindCar: this.searchParams.isBindCar, // 是否绑车
          distributeTimeStart: this.searchParams.time[0], // 分配时间开始
          distributeTimeEnd: this.searchParams.time[1], // 分配时间结束
          insuranceType: this.searchParams.insuranceType, // 保险到期时间
          vehType: this.searchParams.vehType, // 审车到期
          carType: this.searchParams.carType, // 车龄
          vipType: this.searchParams.vipType, // vip到期
          pageIndex: this.searchParams.pageIndex,
          pageSize: this.searchParams.pageSize
        }
      }).then(res => {
        if (res.data.isSuccess) {
          this.tableData = res.data.resultData.content;
          this.totalResult = res.data.resultData.total;
          this.totalPage = res.data.resultData.pageTotal;
        };
      });
    },
    vipClick (e) {
      this.searchParams.pageIndex = 0;
      this.currentPage = 1;
      this.userChange = e;
      if (e === 0) { // 不限
        this.searchParams.time = [];
      } else if (e === 1) { // 今天
        var today = this.GetDateStr(0); // 获取AddDayCount天后的日期
        this.searchParams.time[0] = today + ' ' + '00:00:00';
        this.searchParams.time[1] = today + ' ' + '23:59:59';
      } else if (e === 2) { // 昨天
        var losed = this.GetDateStr(-1); // 获取AddDayCount天后的日期
        this.searchParams.time[0] = losed + ' ' + '00:00:00';
        this.searchParams.time[1] = losed + ' ' + '23:59:59';
      }
      this.getList();
    },
    vipDateClick (e) {
      this.searchParams.vipType = e;
      this.searchParams.pageIndex = 0;
      this.currentPage = 1;
      this.vipEnd = e;
      this.getList();
    },
    shencheClick (e) {
      this.searchParams.vehType = e;
      this.searchParams.pageIndex = 0;
      this.currentPage = 1;
      this.vehEnd = e;
      this.getList();
    },
    baoxianClick (e) {
      this.searchParams.insuranceType = e;
      this.searchParams.pageIndex = 0;
      this.currentPage = 1;
      this.insuranceEnd = e;
      this.getList();
    },
    carYearClick (e) {
      this.searchParams.carType = e;
      this.searchParams.pageIndex = 0;
      this.currentPage = 1;
      this.carYear = e;
      this.getList();
    },
    // 搜索列表
    submitSearch () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 搜索列表
    submitSearch1 () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 清除
    searchClear (num) {
      if (num === 1) {
        this.clearListSearch();
      } else if (num === 2) {
        this.clearListSearch2();
        this.getUserList();
      }
    },
    // 清除列表的搜索表单
    clearListSearch () {
      this.searchParams = {
        mobile: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 0
      };
      this.getList();
    },
    // 创建任务
    creatTask () {
      let obj = '';
      this.multipleSelection.forEach(item => {
        obj += item.memberTel + ',';
      });
      this.newList = obj.substring(0, obj.length - 1);
      this.$router.push({name: 'addTask', query: {table: this.newList, fromUrl: 'cilent'}});
    },
    // 设置星标 (0设置星标 1取消星标 与是否是星标正好相反)
    setStar (e) {
      let title = e.isStar ? '确定要取消星标吗?' : '确定要设置星标吗?';
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let param = {
            memberId: e.memberId,
            isStar: e.isStar ? '1' : '0'
          };
          this.axios
            .post(`/member/setMemberStar`, param)
            .then(res => {
              if (res.data.isSuccess) {
                this.$router.go(0);
                this.$message.success(res.data.message);
              } else {
                this.$message.info(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
    },
    getRowKeys1 (row) {
      return row.memberId;
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
      this.selectLength = val.length;
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    },
    // 打开提交审核
    openSubmit (obj) {
      console.log(obj);
      this.$router.push({name: 'customerCheck', query: {data: obj, mobile: obj.memberTel, isStar: obj.isStar}});
    },
    openCall (obj) {
      console.log(obj);
      let param = {
        number: obj.memberTel
      };
      // https://{yourdomain}.kf5.com/voice/outbound
      this.axios
        .post(`/doubleTask/outbound`, param)
        .then(res => {
          if (res.data.isSuccess) {
            this.$message.success(res.data.message);
          } else {
            this.$message.warning(res.data.message);
          }
        });
    },
    dialogShow () {
      this.dialog.submit.show = true;
      this.dialog.submit.userName = '';
      this.dialog.submit.password = '';
    },
    bindCall () { // 呼叫失败需要录入客服账号
      if (this.dialog.submit.userName === '' || this.dialog.submit.password === '') {
        this.$message.warning('用户名或密码不能为空');
      } else {
        let param = {
          kf5Name: this.dialog.submit.userName,
          kf5Pwd: this.dialog.submit.password
        };
        this.axios
          .post(`/doubleTask/bindKf5Info`, param)
          .then(res => {
            if (res.data.isSuccess) {
              this.$message.success(res.data.message);
              this.dialog.submit.show = false;
            } else {
              this.$message.warning(res.data.message);
            }
          });
      }
    },
    GetDateStr (AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1; // 获取当前月份的日期
      var d = dd.getDate();
      return y + '-' + m + '-' + d;
    },
    submitConfirm () {
      this.axios({
        url: `/agentAwardBatch/transfer` + devCode,
        method: 'post',
        data: {
          ids: this.ids
        }
      }).then(res => {
        if (res.data.ok) {
          this.$message.success(res.data.data);
          this.dialog.submit.show = false;
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
.el-button--text {color: #aaa;}
</style>
<style>
  .searchs {width: 100%; padding: 0px 20px 10px; float: left; font-size: 14px;}
  .searchs .right_time {display: inline; position: relative;}
  .searchs .searchInline span { margin-left: 10px; }
  .searchs .searchInline .blue {color: blue;}
  .contentView .top_table {
    margin-top: 20px; display: flex; height: 50px; width: 100%;
    background: #dedccc; padding: 0 10px; justify-content: space-between;
  }
  .contentView .top_table .left {display: flex;}
  .contentView .top_table .tip_btn { font-size: 14px; line-height: 50px;}
  .contentView .top_table .tip_btn:last-child {margin-left: 20px;}
  .contentView .top_table .right_btn {
  font-size: 14px; line-height: 30px; border-radius: 5px 5px;padding: 0 5px;
  background: #25a0ef; color: #fff; height: 30px; margin-top: 10px; cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/clientManage/myClient.vue